import React, { FC } from 'react';
import styled from 'styled-components';
import { Heading3 } from '@hox/ui/Typography';
import { LinkButton } from '@hox/ui/Button';
import { FormattedMessage } from 'react-intl';

interface ILogoutProps {}

const LogoutStyled = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  > * {
    margin-bottom: 1.5rem;
    :last-child {
      margin-bottom: 0;
    }
  }
`;

const Logout: FC<ILogoutProps> = () => (
  <LogoutStyled>
    <Heading3>
      <FormattedMessage
        id="auth.logout.title"
        defaultMessage="Logout successful"
        description="On logout client is forwarded to this page, title of logout page"
      />
    </Heading3>
    <LinkButton color="primary" to="/">
      <FormattedMessage
        id="auth.general.backToLoginButton"
        defaultMessage="Back to login"
        description="Back to login button text"
      />
    </LinkButton>
  </LogoutStyled>
);

export { Logout };
